import React, { useEffect } from 'react';
import { createInstance, MatomoProvider as MatomoTrackerProvider } from '@datapunt/matomo-tracker-react';
import { useLocation } from 'react-router-dom';
import { MATOMO_CONFIG } from '../config/matomo.js';

// Create the Matomo instance with our configuration
const instance = createInstance(MATOMO_CONFIG);

/**
 * MatomoProvider component that wraps the application and provides Matomo tracking
 * This component also tracks page views automatically when the route changes
 */
const MatomoProvider = ({ children }) => {
  const location = useLocation();

  // Track page view when the route changes
  useEffect(() => {
    // Track page view
    instance.trackPageView({
      href: window.location.href,
      documentTitle: document.title,
    });
  }, [location]);

  return (
    <MatomoTrackerProvider value={instance}>
      {children}
    </MatomoTrackerProvider>
  );
};

export default MatomoProvider;

// Export the instance for direct use in components
export { instance as matomoInstance };